import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import ServiceAreaForm from './ServiceAreaForm';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
};

const ServiceAreaContainer = ({ classes }) => (
  <div className={classes.root}>
    <div className={classes.innerWrapper}>
      <div className={classes.personalWrapper}>
        <ServiceAreaForm />
      </div>
    </div>
  </div>
);

ServiceAreaContainer.propTypes = propTypes;

export default withStyles(styles)(ServiceAreaContainer);
